<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>微盘</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表">
        <!-- 查询用户 start -->
        <el-form :inline="true" label-width="82px">
          <el-form-item>
            <el-button type="primary" @click="clickback">返回上一级</el-button>
            <TencentyunCosUploadFile @change="changeTencentyunCosUploadFile" v-if="curUploadPermissions == 1"></TencentyunCosUploadFile>
            <el-button type="success" @click="clickAddFolder" v-if="SubRule_MicroDisk_AddFolder">新建文件夹</el-button>
            <el-button type="warning" @click="clickPaste" v-if="ButtonPaste">粘贴</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe>
          <el-table-column prop="" label="名称" min-width="30%">
            <template v-slot="scope">
              <el-image style="width: 24px; height: 24px" :src="scope.row.Fileextensionimage" ></el-image>
              <el-button v-if="scope.row.Filetype == 0" type="text" @click="clickFolder(scope.row)">{{scope.row.Filename}}</el-button>
              <el-link v-if="scope.row.Filetype == 1" :href="scope.row.Fileurl" target="_blank">{{scope.row.Filename}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="Filesize" label="大小(KB)" min-width="10%"></el-table-column>
          <el-table-column prop="ViewUserNames" label="谁有权限查看" min-width="15%" v-if="SubRule_MicroDisk_AddFolder"></el-table-column>
          <el-table-column prop="UploadUserNames" label="谁有权限上传" min-width="15%" v-if="SubRule_MicroDisk_AddFolder"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="15%"></el-table-column>
          <el-table-column label="操作" min-width="15%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Filetype == 0 && SubRule_MicroDisk_RenameFolder" @click="goRenameFolder(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Filetype == 0 && SubRule_MicroDisk_MoveFolder" @click="goMoveFolder(scope.row)">移动</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Filetype == 0 && SubRule_MicroDisk_DelFolder" @click="goDelFolder(scope.row)">删除</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Filetype == 0 && SubRule_MicroDisk_AddFolder" @click="openViewDialog(scope.row)">查看权限</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Filetype == 0 && SubRule_MicroDisk_AddFolder" @click="openUploadDialog(scope.row)">上传权限</el-button>

              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Filetype == 1" @click="goDownloadFile(scope.row)">下载</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Filetype == 1 && curUploadPermissions == 1" @click="goDelFile(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 清单列表 end -->

    </el-tabs>
    <!-- Tabs end -->

    <!-- 新建文件夹 -->
    <el-dialog title="新建文件夹" :visible.sync="AddFolderDialog" width="30%" :show-close="false">
      <el-form :model="AddFolderForm" ref="AddFolderFormRef" label-width="90px">
        <el-form-item label="文件夹名称" class="addAdminForm">
          <el-input v-model="AddFolderForm.filename" placeholder="请输入文件夹名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveAddFolder">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 新建文件夹 -->

    <!-- 修改文件夹 -->
    <el-dialog title="修改文件夹" :visible.sync="EditFolderDialog" width="30%" :show-close="false">
      <el-form :model="EditFolderForm" ref="EditFolderFormRef" label-width="90px">
        <el-form-item label="文件夹名称" class="addAdminForm">
          <el-input v-model="EditFolderForm.filename" placeholder="请输入文件夹名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveEditFolder">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 修改文件夹 -->

    <!-- 设置查看权限 -->
    <el-dialog title="设置查看权限" :visible.sync="ViewDialog" width="50%" :show-close="false">
      <el-form :model="ViewForm" ref="ViewFormRef" label-width="150px">
        <el-form-item>
          <el-transfer v-model="selectViewEmployees" :data="allEmployees"></el-transfer>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveViewDialog">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 设置查看权限 -->

    <!-- 设置上传权限 -->
    <el-dialog title="设置上传权限" :visible.sync="UploadDialog" width="50%" :show-close="false">
      <el-form :model="UploadForm" ref="UploadFormRef" label-width="150px">
        <el-form-item>
          <el-transfer v-model="selectUploadEmployees" :data="allEmployees"></el-transfer>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveUploadDialog">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 设置上传权限 -->

  </div>
</template>

<script>
import TencentyunCosUploadFile from '@/components/TencentyunCosUploadFile.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadFile
  },
  name: 'MyMicroDisk',
  data () {
    return {
      dataList: [],
      curparentid: '0',
      shangparentid: [],
      curUploadPermissions: '0',
      shangUploadPermissions: [],
      allEmployees: [],
      selectViewEmployees: [],
      selectUploadEmployees: [],
      selectFileId: 0,
      // 添加设备
      addDevice: {
        jigouid: '0',
        jigouname: '',
        mac: '',
        cardnumber: '',
        producename: '',
        producetime: ''
      },
      AddFolderDialog: false,
      EditFolderDialog: false,
      ViewDialog: false,
      UploadDialog: false,
      AddFolderForm: {
        filename: ''
      },
      EditFolderForm: {
        microdiskid: '',
        filename: ''
      },
      ViewForm: {
      },
      UploadForm: {
      },
      ButtonPaste: false,
      Movemicrodiskid: 0,
      SubRule_MicroDisk_AddFolder: false,
      SubRule_MicroDisk_RenameFolder: false,
      SubRule_MicroDisk_MoveFolder: false,
      SubRule_MicroDisk_DelFolder: false
    }
  },
  mounted () {
    this.apiGetMicroDiskFileList()
    this.apiGeterpuserneibulist()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_MicroDisk_AddFolder', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MicroDisk_AddFolder = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_MicroDisk_RenameFolder', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MicroDisk_RenameFolder = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_MicroDisk_MoveFolder', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MicroDisk_MoveFolder = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_MicroDisk_DelFolder', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MicroDisk_DelFolder = true
      }
    })
  },
  methods: {
    changeTencentyunCosUploadFile (url, filename, fileextension, filesize) {
      var parentid = this.curparentid
      var filetype = 1
      this.apiAddMicroDiskFile(parentid, filetype, filename, fileextension, filesize, url)
    },
    openViewDialog(row){
      this.ViewDialog = true
      this.selectFileId = row.Id
      this.selectViewEmployees = row.ViewUserIds
    },
    saveViewDialog(){
      this.apiAddMicroDiskPermissions(this.selectFileId,1,this.selectViewEmployees.toString())
    },
    openUploadDialog(row){
      this.UploadDialog = true
      this.selectFileId = row.Id
      this.selectUploadEmployees = row.UploadUserIds
    },
    saveUploadDialog(){
      this.apiAddMicroDiskPermissions(this.selectFileId,2,this.selectUploadEmployees.toString())
    },
    clickback () {
      if (this.shangparentid.length > 0) {
        // pop方法是与push对应的，删除并返回数组的最后一个元素，数组长度-1
        this.curparentid = this.shangparentid.pop()
        this.apiGetMicroDiskFileList()
      }
      if (this.shangUploadPermissions.length > 0) {
        this.curUploadPermissions = this.shangUploadPermissions.pop()
      }
    },
    clickAddFolder () {
      this.AddFolderDialog = true
    },
    saveAddFolder () {
      var parentid = this.curparentid
      var filetype = 0
      var filename = this.AddFolderForm.filename
      var fileextension = 'folder'
      var filesize = 0
      var fileurl = 'folder'
      this.apiAddMicroDiskFile(parentid, filetype, filename, fileextension, filesize, fileurl)
    },
    saveEditFolder () {
      this.apiRenameMicroDiskFile()
    },
    clickFolder (row) {
      // push方法就是将要添加的元素添加到数组的末尾，数组长度+1
      this.shangparentid.push(this.curparentid)
      this.curparentid = row.Id
      this.shangUploadPermissions.push(this.curUploadPermissions)
      this.curUploadPermissions = row.HaveUploadPermissions
      this.apiGetMicroDiskFileList()
    },
    clickPaste () {
      this.apiMoveMicroDiskFile()
    },
    // 重命名文件夹
    goRenameFolder (row) {
      this.EditFolderDialog = true
      this.EditFolderForm.filename = row.Filename
      this.EditFolderForm.microdiskid = row.Id
    },
    // 移动文件夹
    goMoveFolder (row) {
      this.ButtonPaste = true
      this.Movemicrodiskid = row.Id
    },
    // 删除文件夹
    goDelFolder (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelMicroDiskFile(row.Id)
      })
    },
    // 下载文件
    goDownloadFile (row) {
      window.open(row.Fileurl)
    },
    // 移动文件
    goMoveFile (row) {
      this.goMoveFolder(row)
    },
    // 删除文件
    goDelFile (row) {
      this.goDelFolder(row)
    },
    apiGetMicroDiskFileList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: that.curparentid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMicroDiskFileList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddMicroDiskFile: function (parentid, filetype, filename, fileextension, filesize, fileurl) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: parentid,
        filetype: filetype,
        filename: filename,
        fileextension: fileextension,
        filesize: filesize,
        fileurl: fileurl
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddMicroDiskFile, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetMicroDiskFileList()
            that.AddFolderDialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRenameMicroDiskFile: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        microdiskid: that.EditFolderForm.microdiskid,
        filename: that.EditFolderForm.filename
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RenameMicroDiskFile, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetMicroDiskFileList()
            that.EditFolderDialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiMoveMicroDiskFile: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        microdiskid: that.Movemicrodiskid,
        parentid: that.curparentid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_MoveMicroDiskFile, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetMicroDiskFileList()
            that.ButtonPaste = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelMicroDiskFile: function (microdiskid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        microdiskid: microdiskid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelMicroDiskFile, Qs.stringify(data))
        .then(function (response) {
          that.apiGetMicroDiskFileList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGeterpuserneibulist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Geterpuserneibulist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.allEmployees = [{ key: 0, label: '所有人' }]
            response.data.List.filter((item1, i1) => {
              that.allEmployees.push({ key: Number(item1.Id), label: item1.Name })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddMicroDiskPermissions: function (fileid, permissionstype, selectlist) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fileid: fileid,
        permissionstype: permissionstype,
        selectlist: selectlist
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddMicroDiskPermissions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetMicroDiskFileList()
            that.ViewDialog = false
            that.UploadDialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
